<template>
  <Dialog :visible="visible" class="share-dialog layout-content" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '90vw'}" :draggable="false"
              @update:visible="updateVisible" >

    <div class="irinox-form" >
      <div class="search-bar" style="float: right">
        <i class="pi pi-search" />
        <InputText v-model="filters['global'].value" :placeholder="$t('admin.appliances.search_short')" style="width:70px" :aria-label="$t('admin.appliances.search_short')"/>
        <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
      </div>
      <div class="p-formgroup-inline p-ai-center">
        <div class="p-field">
          <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
            :placeholder="$t('admin.appliances.filter_model_ph')" />
        </div>
        <div class="p-field">
          <Dropdown id="laboratory" v-model="filters['laboratory'].value" :options="laboratories" optionLabel="name" optionValue="code"
            :placeholder="$t('admin.appliances.filter_lab_ph')" />
        </div>
        <div class="p-field">
          <ToggleButton v-model="statusButton" :onLabel="$t('admin.appliances.filter_online')" :offLabel="$t('admin.appliances.filter_online')"  :aria-label="$t('common.online')+'/'+$t('common.offline')" />      
        </div>
      </div>
    </div>
    
    <DataTable :value="appliances" v-model:selection="selectedAppliances" stripedRows 
      v-model:filters="filters" responsiveLayout="stack" dataKey="serialNumber" 
       breakpoint="900px" sortField="serialNumber" :sortOrder="1">
      <template #empty>
          {{$t('admin.appliances.empty_list')}}
      </template>
      <template #loading>
          {{$t('admin.appliances.loading_list')}}
      </template>
      <Column field="serialNumber" :header="$t('admin.appliances.col_serialnumber')" ></Column>
      <Column field="modelNumber" filterField="modelNumber" :header="$t('admin.appliances.col_model')" >
        <template #body="slotProps">
          <div>
            {{$functions.fixModelName(slotProps.data.modelNumber)}} 
            <img v-if="slotProps.data.online" src="assets/irinox/icons/status_online_small.svg" class="p-pl-1" :alt="$t('common.online')"/>
            <img v-else src="assets/irinox/icons/status_offline_small.svg" class="p-pl-1"  :alt="$t('common.offline')"/>
          </div>
        </template>
      </Column>
      <Column field="name" :header="$t('admin.appliances.col_name')" >
        <template #body="slotProps">
          <div>
            {{slotProps.data.name ?? slotProps.data.modelNumber}}
          </div>
        </template>
      </Column>
      <Column field="labName" filterField="laboratory" :header="$t('admin.appliances.col_lab')" ></Column>
      <Column selectionMode="multiple" style="width:70px">
        <template #header>
          <span class="sr-only">{{$t('common.select')}}</span>
        </template>
      </Column>
    </DataTable>

    <ScrollTop target="parent" />
    
    <template #footer>
      <Button :label="$t('admin.appliances.share_dialog_cancel_button')" @click="leftButtonClick" class="p-button-secondary" />
      <Button :label="$t('admin.appliances.share_dialog_ok_button')" @click="rightButtonClick"/>
    </template>
  </Dialog>
</template>

<script>
import ApplianceService from '../service/ApplianceService';
import {FilterMatchMode} from 'primevue/api';

export default {
    emits: ['update:visible','click:left-button','click:right-button'],
    props: {
      visible: Boolean,
      email: String,
      leftB: {
        type: String,
        required: false
      },
      rightB: {
        type: String,
        required: false
      },
      preselectedAppliances: Array
    },
    data() {
        return {
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'laboratory': {value: null, matchMode: FilterMatchMode.EQUALS},
              'online': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          appliances: [],
          selectedAppliances: [],
          modelNumbers: [],
          laboratories: [],
          statusButton: false,
        };
    },
    computed: {
      personaltoken: function() {
          return this.$store.getters['userdata/personaltoken'];
      },
    },
    watch: {
      preselectedAppliances: 'preselectAppliances',
      appliances: 'loadFilters',
      statusButton: 'statusButtonToggle'
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    mounted() {
      // if(this.mode=='user') {
        this.applianceService.getAdminAppliances(this.personaltoken)
          .then((appliances) => {
            this.appliances = appliances;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.appliances = [];
          });
      // } else if(this.mode=='factory') {
      //   this.applianceService.getFactoryAppliances(this.personaltoken)
      //     .then((appliances) => {
      //       this.appliances = appliances;
      //     })
      //     .catch(error => {
      //       console.error("EXCEPTION "+error);
      //       this.appliances = [];
      //     });
      // }
    },
    methods: {
      preselectAppliances() {
        this.selectedAppliances = this.preselectedAppliances;
      },
      updateVisible(value) {
        this.$emit("update:visible", value);
      },
      leftButtonClick() {
        this.preselectAppliances();
        this.$emit("click:left-button");
      },
      rightButtonClick() {
        this.$emit("click:right-button", this.selectedAppliances);
      },
      loadFilters() {
        this.modelNumbers = [];
        this.laboratories = [];
        for (let i = 0; i < this.appliances.length; i++) {
          this.modelNumbers.push({ 
            code: this.appliances[i].modelNumber,
            name: this.$functions.fixModelName(this.appliances[i].modelNumber)
          });
          if(this.appliances[i].labName) {
            this.laboratories.push({ 
              code: this.appliances[i].labName,
              name: this.appliances[i].labName 
            });
          }
        }
        this.modelNumbers = this.$functions.uniqByKeepFirst(this.modelNumbers, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.modelNumbers.unshift({ 
          code: null,
          name: this.$t('admin.appliances.filter_remove') 
        });
        this.laboratories = this.$functions.uniqByKeepFirst(this.laboratories, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.laboratories.unshift({ 
          code: null,
          name: this.$t('admin.appliances.filter_remove') 
        })
      },
      statusButtonToggle() {
        if(this.statusButton) {
          this.filters['online'].value = true;
        } else {
          this.filters['online'].value = null;
        }
      }
    }
}
</script>

<style>

/* .p-dialog.share-dialog {
  box-shadow: none;
  height: 100vh;
} */

.p-dialog.share-dialog .p-dialog-content {
  padding: 0 0 2rem 0;
  height: 90vh;
}
.p-dialog.share-dialog .p-dialog-content .irinox-form {
  padding: 0 1.5rem 0 1.5rem;
}
.p-dialog.share-dialog .p-dialog-content .irinox-form .p-dropdown {
  width: 200px;
}

.share-dialog.layout-content {
  flex: none;
  padding: 0;
}

</style>